<template>
  <div class="container_option_item d-flex flex-wrap justify-start align-start gap bordered rounded bg-grey_1 pa-1 mb-2"
    :class="[group_with_last ? '' : 'mt-1']">
    <div class="container_visuel_option bordered rounded" v-if="has_visuel">
      <a :href="has_visuel.valeur" target="_blank">
        <img class="visuel_option" :src="has_visuel.valeur" :alt="'visuel ' + option.nom" />
      </a>
    </div>
    <div class="d-flex flex-column">
      <div class="text-h6 ml-1" style="margin-right: auto">{{ option.nom }} - {{ option.get_text_prix() }}</div>
      <div class="text-body ml-1" v-if="option.information_supplementaire != ''"
        v-html="option.information_supplementaire">
      </div>
      <div class="text-body ml-1" v-if="option.information_variante_tarif != ''">{{ option.information_variante_tarif }}
      </div>
      <div class="text-body ml-1">Places réservables restantes: {{ places_disponibles }}</div>
    </div>

    <div
      v-if="option.is_selectionnable('ouverte', mainStore.view_as_admin, mainStore.inscription_as_admin, mainStore.inscription_vip)"
      class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
      <div class="text-body-1 pt-2">Quantité</div>
      <v-btn @click="minus_quantity"><v-icon icon="mdi-minus"></v-icon> </v-btn>
      <div class="text-h6">{{ option.quantite_souhaite }}</div>
      <v-btn @click="plus_quantity"><v-icon icon="mdi-plus"></v-icon> </v-btn>
    </div>

    <div class="justify-self-end" v-else-if="option.is_complet()">
      <v-chip square color="dark-red">Complet</v-chip>
    </div>
    <div class="justify-self-end" v-else-if="option.is_closed()">
      <v-chip square color="dark-red">Inscriptions closes</v-chip>
    </div>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
export default {
  props: ["item", "group_with_last", "options_coureur"],
  data() {
    return {
      desired_quantity: 0,
      option: {},
      items: [],
      max_reservable: 0,
    };
  },

  computed: {
    ...mapStores(useMainStore, useBookingStore),
    all_options() {
      return this.mainStore.module.options.list;
    },
    has_visuel() {
      let visuel = this.option.metadatas.filter((metadata) => metadata.nom == "visuel_option");
      if (visuel.length > 0) {
        return visuel[0];
      }
      return false;
    },
    places_disponibles() {
      const inscriptions = this.bookingStore.inscriptions;
      return this.option.get_places_disponibles(this.all_options, this.options_coureur, inscriptions, this.mainStore.inscription_vip, false, [], this.bookingStore.initial_commande_inscription);
    }
  },

  methods: {
    minus_quantity() {
      if (this.option.quantite_souhaite > 0) {
        this.option.quantite_souhaite--;
        this.option.handle_minimum_quantity();
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.places_disponibles > 0) {
        this.option.quantite_souhaite++;
        this.$emit("updateQuantite", this.option.quantite_souhaite);
      }
    },

    build_quantity_items() {
      for (let i = 0; i < this.places_disponibles; i++) {
        this.items.push(i);
      }
    },



  },
  created() {
    this.option = this.item;
    this.build_quantity_items();
    this.option.handle_minimum_quantity();
    this.$emit("updateQuantite", this.option.quantite_souhaite);
  },
};
</script>

<style lang="scss" scoped></style>